import "./tournament-message-scheduled-confirmation.scss";
import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { faChevronLeft, faClock } from "@fortawesome/free-solid-svg-icons";
import { useMatch, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  clearNotifications,
  selectCurrentMessage,
  selectCurrentMessageRecipientGroups,
  selectSelectedMessageTournaments,
  selectMessagesNotifications,
} from "../../../reducers/messagesSlice";
import { selectCurrentTournament } from "../../../reducers/tournamentSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNotificationBanner } from "../../../hooks/notificationHooks";
import { useRefreshAllRecipients } from "../../../hooks/messageRefreshHooks";
import { confirmationForm } from "../../../forms/ConfirmationForms";
import TournamentMessageConfirmationItem from "./tournament-message-confirmation-item";

const TournamentMessageScheduledConfirmation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const match = useMatch(
    "/:tournamentID/messages/:messageID/schedule/confirmation",
  );

  const currentMessage = useSelector(selectCurrentMessage);
  const recipientGroups = useSelector(selectCurrentMessageRecipientGroups);
  const currentTournament = useSelector(selectCurrentTournament);
  const tournaments = useSelector((state) =>
    selectSelectedMessageTournaments(
      state,
      match?.params?.tournamentID,
      currentTournament,
    ),
  );
  const notifications = useSelector(selectMessagesNotifications);

  const { refreshing, refresh, loading } = useRefreshAllRecipients({
    tournamentID: match?.params?.tournamentID,
    messageID: match?.params?.messageID,
    autoRefresh: true,
  });

  const organizationName =
    tournaments.find((t) => t?.id === match?.params?.tournamentID)?.organization
      ?.name ?? currentTournament?.organization?.name;

  const messageType =
    currentMessage?.channel === "email" ? "email" : "app notification";

  const goToMessages = () => {
    dispatch(clearNotifications());
    navigate(`/${match?.params?.tournamentID}/messages`);
  };

  const getNavigation = () => {
    return {
      title: "Message Scheduled",
      leftIcon: faChevronLeft,
      leftButtonClick: goToMessages,
    };
  };

  const getFormTitle = () => {
    return (
      <div className="confirm-header">
        <div className="icon" style={{ color: "#000000" }}>
          <FontAwesomeIcon icon={faClock} />
        </div>
        Message Scheduled
      </div>
    );
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle={getFormTitle()}
        formSections={confirmationForm(
          `This ${messageType} has been scheduled!`,
          <TournamentMessageConfirmationItem
            currentMessage={currentMessage}
            tournaments={tournaments}
            recipientGroups={recipientGroups}
            organizationName={organizationName}
            refreshing={refreshing}
            onRefresh={refresh}
            showRefresh={true}
          />,
        )}
      />
    );
  };

  const getDrawerActions = () => {
    return [
      {
        name: "Done",
        action: goToMessages,
        type: "light-grey",
      },
    ];
  };

  const getDrawer = () => {
    return { actions: getDrawerActions() };
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  const [banner] = useNotificationBanner({ notifications, timeoutAction });

  return (
    <tournament-message-scheduled-confirmation>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        loading={loading}
        loadingText="Preparing for Review..."
        content={getContent()}
        drawer={getDrawer()}
      />
    </tournament-message-scheduled-confirmation>
  );
};

export default TournamentMessageScheduledConfirmation;
